import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { useTheme } from '../../../context/ThemeContext';

interface HeaderProps {
  onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const getPageTitle = () => {
    switch (location.pathname) {
      case '/dashboard':
        return 'Admin Panel';
      case '/users':
        return 'Users Management';
      case '/projects':
        return 'Projects';
      case '/devices':
        return 'Devices';
      case '/player-controls':
        return 'Player Controls Configuration';
      default:
        return 'Admin Panel';
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <button
          type="button"
          className="header-hamburger"
          onClick={onMenuClick}
          title="Open menu"
          aria-label="Open menu"
          aria-expanded={!!onMenuClick}
        >
          <svg className="header-hamburger-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <div className="header-title-wrap">
          <h2 className="header-title">{getPageTitle()}</h2>
          <p className="header-subtitle">
            Welcome back, {user?.name?.trim() || 'Admin'}
          </p>
        </div>
        <div className="header-actions">
          <div className="header-theme-toggle">
            <label className="theme-switch toggle-switch" title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
              <input
                type="checkbox"
                checked={theme === 'light'}
                onChange={toggleTheme}
                aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
              />
              <span className="toggle-slider theme-switch-slider" />
              <span className="theme-switch-label">{theme === 'dark' ? 'Dark' : 'Light'}</span>
            </label>
          </div>
          <button
            type="button"
            className="header-icon-btn"
            onClick={() => navigate('/control-panel')}
            title="Open Control Panel"
            aria-label="Control Panel"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
            </svg>
            <span className="header-logout-label">Control Panel</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
